import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import SyenovixLogo from './SyenovixLogo';

const ACCENT = '#5E0ED7';
const ease = [0.22, 1, 0.36, 1];

const links = {
  Services: ['Custom Software', 'UX/UI Design', 'AI Consulting', 'Digital Transformation', 'Data Engineering'],
  Company: ['About Us', 'Our Process', 'Case Studies', 'Careers', 'Blog'],
  Contact: ['hello@syenovix.com', '+1 (415) 800-9200', 'San Francisco, CA'],
};

function FooterLink({ href, children }) {
  return (
    <motion.a href={href} className="relative inline-block text-sm" style={{ color: '#71717A' }} whileHover="hover">
      {children}
      <motion.span
        className="absolute bottom-0 left-0 h-px w-full"
        style={{ background: '#71717A', transformOrigin: 'left center' }}
        variants={{ hover: { scaleX: 1 }, initial: { scaleX: 0 } }}
        initial="initial"
        transition={{ duration: 0.2, ease }}
      />
    </motion.a>
  );
}

export default function Footer() {
  return (
    <footer
      className="px-5 sm:px-8 md:px-12 lg:px-20 pt-20 pb-10"
      style={{ background: '#111110', color: '#fff' }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <SyenovixLogo height={40} showTagline dark />
            </div>
            <p className="text-sm leading-relaxed max-w-xs mb-6" style={{ color: '#71717A' }}>
              Technology consulting and digital product studio. We help ambitious organizations design, build, and scale transformative technology.
            </p>
            <motion.a
              href="#contact"
              whileTap={{ scale: 0.97 }}
              transition={{ duration: 0.12 }}
              className="inline-flex items-center gap-1.5 text-[13px] font-semibold tracking-wide"
              style={{ color: ACCENT }}
            >
              Start a Project
              <div className="w-5 h-5 rounded-full flex items-center justify-center" style={{ background: `${ACCENT}20` }}>
                <ArrowUpRight size={11} style={{ color: ACCENT }} />
              </div>
            </motion.a>
          </div>

          {/* Links */}
          {Object.entries(links).map(([category, items]) => (
            <div key={category}>
              <h4 className="text-[10px] font-semibold tracking-[0.14em] uppercase mb-5" style={{ color: '#52525B' }}>{category}</h4>
              <ul className="flex flex-col gap-3">
                {items.map((item) => (
                  <li key={item}><FooterLink href="#contact">{item}</FooterLink></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <p className="text-xs" style={{ color: '#52525B' }}>© 2026 Syenovix. All rights reserved.</p>
          <div className="flex gap-6">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((item) => (
              <FooterLink key={item} href="#contact"><span className="text-xs">{item}</span></FooterLink>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
